<template>
  <div id="a-pricing-strategy-strategies">
    <a-base-component :subscribed_modules="subscribed_modules">
      <template v-slot:default>
        <v-row class="mt-2">
          <v-col cols="12" class="text-body-2 font-weight-bold">
            {{ $t("recommendations_description") }}
          </v-col>
        </v-row>
        <v-row class="mt-2">
          <v-col cols="12" class="d-flex align-center justify-space-between">
            <div class="d-flex align-center" style="gap: 10px">
              <!-- Recomendaciones de precio o avisos: mezclados, ni se entendía
                   el día ni se veían los avisos, que quedaban escondidos dentro
                   de un "2 sugerencias" -->
              <v-btn-toggle
                v-model="suggestion_view"
                class="suggestion-view-toggle"
                background-color="transparent"
                color="secondary"
                rounded
                mandatory
              >
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-bind="attrs"
                      v-on="on"
                      value="price"
                      outlined
                      :class="{ 'secondary white--text': isPriceView }"
                    >
                      <v-icon small :color="isPriceView ? 'white' : ''">
                        mdi-currency-eur
                      </v-icon>
                    </v-btn>
                  </template>
                  <span>{{ $t("price_recommendations") }}</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-bind="attrs"
                      v-on="on"
                      value="notify"
                      outlined
                      :class="{ 'secondary white--text': !isPriceView }"
                    >
                      <v-icon small :color="!isPriceView ? 'white' : ''">
                        mdi-bell-outline
                      </v-icon>
                    </v-btn>
                  </template>
                  <span>{{ $t("recommendation_notify") }}</span>
                </v-tooltip>
              </v-btn-toggle>
              <v-select
                v-model="recommendations_strategy_id"
                :label="$t('Strategy')"
                :items="strategies_items"
                hide-details
                outlined
                rounded
                dense
                style="max-width: 200px"
              ></v-select>
              <v-select
                v-model="recommendations_rate_plan_id"
                :label="$t('_rate')"
                :items="strategy_rates_items"
                hide-details
                outlined
                rounded
                dense
                style="max-width: 200px"
              ></v-select>
            </div>
            <div class="d-flex align-center" style="gap: 10px">
              <v-menu v-if="selectedItems.length > 0" offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" color="secondary" rounded>
                    <v-icon size="16" class="mr-2">
                      mdi-numeric-2-circle-outline
                    </v-icon>
                    {{ $t("Bulk_actions") }}
                    <v-icon size="16" class="ml-2">
                      mdi-chevron-down
                    </v-icon>
                  </v-btn>
                </template>
                <v-list dense>
                  <v-list-item @click="showBulkIgnoreConfirmDialog = true">
                    <v-list-item-icon>
                      <v-icon size="16" color="red">mdi-eye-off-outline</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title class="red--text">
                        {{ $t("ignore_selected") }}
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item @click="showBulkReactivateConfirmDialog = true">
                    <v-list-item-icon>
                      <v-icon size="16" color="green">mdi-reload</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title class="green--text">
                        {{ $t("reactivate_selected") }}
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-menu>
              <v-btn
                v-if="fake_suggestions_enabled"
                rounded
                outlined
                color="warning"
                :loading="generating_fake_suggestions"
                @click="generateFakeSuggestions"
              >
                <v-icon small class="mr-2">mdi-flask-outline</v-icon>
                {{ $t("generate_fake_suggestions") }}
              </v-btn>
              <!-- En la vista de avisos no hay ningún precio que enviar -->
              <v-btn
                rounded
                color="secondary"
                :disabled="!isPriceView"
                @click="showApplyAllDialog"
              >
                <v-icon small class="mr-2">mdi-send-outline</v-icon>
                {{ $t("send_all_suggestions") }}
              </v-btn>
            </div>
          </v-col>
        </v-row>
        <template
          v-if="
            formattedRecommendations &&
              Object.keys(formattedRecommendations).length > 0
          "
        >
          <v-row
            v-for="(recommendations, date) in formattedRecommendations"
            :key="date"
            class="card-table-row"
          >
            <v-col cols="12" class="pb-0">
              <a-card no_title>
                <div class="text-h6 text-capitalize my-4">
                  {{ getFormattedDate(date) }}
                </div>
                <v-data-table
                  v-model="selectedItems"
                  :headers="headers"
                  :items="recommendations"
                  :items-per-page="-1"
                  :show-select="isPriceView && isDateToday(date)"
                  :item-class="getRowClass"
                  selectable-key="selectable"
                  item-key="id"
                  hide-default-footer
                  disable-pagination
                >
                  <!-- Slot personalizado para todas las filas -->
                  <template v-slot:item="{ item, headers, isSelected, select }">
                    <tr v-if="!item.isSubRow" :class="getRowClass(item)">
                      <!-- Select -->
                      <td v-if="isPriceView && isDateToday(date)">
                        <v-checkbox
                          v-if="!item.notify_only"
                          :input-value="isSelected"
                          @change="select($event)"
                          color="secondary"
                          class="mt-0 pt-0"
                          hide-details
                          dense
                        ></v-checkbox>
                      </td>

                      <!-- Hour -->
                      <td class="text-left">{{ item.hour }}</td>

                      <!-- Target Day -->
                      <td class="text-center">{{ item.target_day }}</td>

                      <!-- Anticipation -->
                      <td class="text-center">
                        <div>{{ item.anticipation }}</div>
                      </td>

                      <!-- Rate -->
                      <td class="text-center">
                        <div class="text-uppercase">{{ item.rate }}</div>
                      </td>

                      <!-- Initial Price -->
                      <td class="text-center">
                        <a-kpi
                          v-if="item.price_initial"
                          kpi="price"
                          :value="item.price_initial"
                          class="a-kpi-price"
                          absolute
                        ></a-kpi>
                      </td>

                      <!-- Difference -->
                      <!-- display:flex en un <td> lo saca del modelo de caja de
                           la tabla y sus bordes dejan de cuadrar con la fila:
                           la celda sigue siendo celda y el flex va dentro -->
                      <td v-if="isPriceView" class="text-center">
                        <div class="d-flex justify-center">
                          <a-kpi
                            v-if="item.price_suggestion && item.price_initial"
                            kpi="price"
                            :value="item.price_suggestion"
                            :vs_values="[item.price_initial]"
                            class="a-kpi"
                            absolute
                            hide_kpi
                            hide_tooltip
                            small
                          ></a-kpi>
                        </div>
                      </td>

                      <!-- Suggestion -->
                      <td class="text-center">
                        <a-kpi
                          v-if="item.price_suggestion"
                          kpi="price"
                          :value="item.price_suggestion"
                          class="a-kpi-price"
                          absolute
                        ></a-kpi>
                        <!-- Un aviso no propone precio: ocupa este sitio con la
                             campana de Alertas, coloreada según su prioridad.
                             En la vista de avisos la columna es "Nivel" y la
                             campana sola no dice cuál: va con su literal. -->
                        <div
                          v-else-if="isNotify(item)"
                          class="d-flex align-center justify-center"
                          style="gap: 5px"
                        >
                          <v-icon size="20" :color="notifyColor(item)">
                            mdi-bell-outline
                          </v-icon>
                          <span
                            class="text-caption font-weight-bold"
                            :class="notifyTextClass(item)"
                          >
                            {{ notifyLevel(item) }}
                          </span>
                        </div>
                      </td>

                      <!-- Measure: por qué ha saltado la sugerencia -->
                      <td class="text-center">
                        <span
                          v-if="!item.has_multiple_suggestions"
                          class="text-caption"
                        >
                          {{ getMeasureText(item.single_suggestion) }}
                        </span>
                        <div
                          v-else
                          class="d-flex align-center justify-center text-caption grey--text"
                          style="gap: 5px; cursor: pointer"
                          @click="handleExpandClick(date, item)"
                        >
                          {{ item.suggestions_count }}
                          {{ getSuggestionsText(item.suggestions_count) }}
                          <v-icon small>
                            {{
                              item.isExpanded
                                ? "mdi-chevron-up"
                                : "mdi-chevron-down"
                            }}
                          </v-icon>
                        </div>
                      </td>

                      <!-- Rule -->
                      <td class="text-center">
                        <div
                          v-if="
                            !item.has_multiple_suggestions &&
                              item.single_suggestion_rule
                          "
                        >
                          <a-pricing-strategy-card-strategy-rule-mini
                            :rule="item.single_suggestion_rule"
                            :suggestion="item.single_suggestion"
                          ></a-pricing-strategy-card-strategy-rule-mini>
                        </div>
                      </td>

                      <!-- Actions -->
                      <td v-if="isPriceView" class="text-right">
                        <!-- Sin precio propuesto no hay nada que aplicar. -->
                        <div
                          v-if="!item.notify_only"
                          class="py-2 d-flex justify-end"
                        >
                          <a-pricing-strategy-apply-strategy
                            :ref="`applyStrategy_${item.id}`"
                            :suggestion="item"
                            hide-chip
                            :hide-input="isPastDate(date)"
                            show-modified
                          ></a-pricing-strategy-apply-strategy>
                        </div>
                      </td>
                    </tr>

                    <!-- Subfilas -->
                    <tr v-else :class="getRowClass(item)">
                      <!-- Marca de "no ha contado": la regla saltó, pero otra
                           pasó por encima y su importe no está en el precio -->
                      <!-- Select - vacío para subfilas -->
                      <td v-if="isPriceView && isDateToday(date)"></td>

                      <!-- Hour -->
                      <td class="text-left"></td>

                      <!-- Target Day -->
                      <td class="text-center"></td>

                      <!-- Anticipation -->
                      <td class="text-center"></td>

                      <!-- Rate -->
                      <td class="text-center text-uppercase">
                        {{ item.rate }}
                      </td>

                      <!-- Initial Price -->
                      <td class="text-center">
                        <a-kpi
                          v-if="item.price_initial"
                          kpi="price"
                          :value="item.price_initial"
                          class="a-kpi-price"
                          absolute
                        ></a-kpi>
                      </td>

                      <!-- Difference -->
                      <!-- display:flex en un <td> lo saca del modelo de caja de
                           la tabla y sus bordes dejan de cuadrar con la fila:
                           la celda sigue siendo celda y el flex va dentro -->
                      <td v-if="isPriceView" class="text-center">
                        <div class="d-flex justify-center">
                          <a-kpi
                            v-if="item.price_suggestion && item.price_initial"
                            kpi="price"
                            :value="item.price_suggestion"
                            :vs_values="[item.price_initial]"
                            class="a-kpi"
                            absolute
                            hide_kpi
                            hide_tooltip
                            small
                          ></a-kpi>
                        </div>
                      </td>

                      <!-- Suggestion -->
                      <td class="text-center">
                        <a-kpi
                          v-if="item.price_suggestion"
                          kpi="price"
                          :value="item.price_suggestion"
                          class="a-kpi-price"
                          absolute
                        ></a-kpi>
                        <!-- Un aviso no propone precio: ocupa este sitio con la
                             campana de Alertas, coloreada según su prioridad.
                             En la vista de avisos la columna es "Nivel" y la
                             campana sola no dice cuál: va con su literal. -->
                        <div
                          v-else-if="isNotify(item)"
                          class="d-flex align-center justify-center"
                          style="gap: 5px"
                        >
                          <v-icon size="20" :color="notifyColor(item)">
                            mdi-bell-outline
                          </v-icon>
                          <span
                            class="text-caption font-weight-bold"
                            :class="notifyTextClass(item)"
                          >
                            {{ notifyLevel(item) }}
                          </span>
                        </div>
                      </td>

                      <!-- Measure: por qué ha saltado la sugerencia -->
                      <td class="text-center">
                        <span class="text-caption">
                          {{ getMeasureText(item.single_suggestion) }}
                        </span>
                        <v-tooltip
                          v-if="item.overriddenBy"
                          bottom
                          color="black"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon
                              v-bind="attrs"
                              v-on="on"
                              size="14"
                              class="ml-1"
                              color="grey"
                            >
                              mdi-information-outline
                            </v-icon>
                          </template>
                          <span>
                            {{
                              $t("suggestion_overridden_by", {
                                rule: item.overriddenBy
                              })
                            }}
                          </span>
                        </v-tooltip>
                      </td>

                      <!-- Rule -->
                      <td class="text-center">
                        <a-pricing-strategy-card-strategy-rule-mini
                          v-if="item.suggestion_rule"
                          :rule="item.suggestion_rule"
                          :suggestion="item.single_suggestion"
                        ></a-pricing-strategy-card-strategy-rule-mini>
                      </td>

                      <!-- Actions -->
                      <td v-if="isPriceView" class="text-right">
                        <!-- Vacía para sugerencias -->
                      </td>
                    </tr>
                  </template>
                </v-data-table>
              </a-card>
            </v-col>
          </v-row>
        </template>
        <template v-else>
          <v-row>
            <v-col cols="12">
              <a-card no_title>
                <div class="text-h6 text-center mt-7 mb-4">
                  {{ $t("no_recommendations_found") }}
                </div>
              </a-card>
            </v-col>
          </v-row>
        </template>
      </template>
      <template v-slot:loading>
        <v-card>
          <v-card-text>
            <v-skeleton-loader type="table"> </v-skeleton-loader>
          </v-card-text>
        </v-card>
      </template>
    </a-base-component>

    <!-- Diálogo de confirmación para enviar todas las sugerencias -->
    <v-dialog v-model="showConfirmationDialog" max-width="800px" persistent>
      <v-card>
        <v-card-title class="text-h5">
          {{ $t("confirm_send_all_suggestions") }}
        </v-card-title>

        <v-card-text>
          <div class="text-body-2 mb-4">
            {{
              $t("about_to_send_suggestions", {
                count: pendingSuggestionsForConfirmation.length
              })
            }}
          </div>

          <ul class="suggestions-list">
            <li
              v-for="suggestion in pendingSuggestionsForConfirmation"
              :key="suggestion.id"
              class="suggestion-item"
            >
              <strong>{{ getFormattedDate(suggestion.target_date) }}</strong>
              - {{ $t("initial_price") }}: {{ suggestion.price_initial }}€ →
              {{ $t("final_price") }}:
              <strong>{{ suggestion.price }}€</strong>
            </li>
          </ul>
        </v-card-text>

        <v-card-actions class="ps-5 pb-5 justify-center">
          <v-btn
            color="secondary"
            class="pl-5 pr-5"
            rounded
            @click="confirmSendAll"
          >
            {{ $t("apply") }}
          </v-btn>
          <v-btn
            color=""
            text
            rounded
            depressed
            class="pl-5 pr-5"
            @click="showConfirmationDialog = false"
          >
            {{ $t("cancel") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Diálogo de confirmación para ignorar todas las sugerencias -->
    <v-dialog
      v-model="showBulkIgnoreConfirmDialog"
      max-width="800px"
      persistent
    >
      <v-card>
        <v-card-title class="text-h5">
          {{ $t("confirm_ignore_all_suggestions") }}
        </v-card-title>
        <v-card-text>
          <div class="text-body-2 mb-4">
            {{
              $t("about_to_ignore_suggestions", {
                count: selectedItems.length
              })
            }}
          </div>
          <ul class="suggestions-list">
            <li
              v-for="suggestion in selectedItems"
              :key="suggestion.id"
              class="suggestion-item"
            >
              <strong>{{ getFormattedDate(suggestion.target_date) }}</strong>
              - {{ $t("initial_price") }}: {{ suggestion.price_initial }}€ →
              {{ $t("final_price") }}:
              <strong>{{ suggestion.price_suggestion }}€</strong>
            </li>
          </ul>
        </v-card-text>

        <v-card-actions class="ps-5 pb-5 justify-center">
          <v-btn
            color="secondary"
            class="pl-5 pr-5"
            rounded
            @click="confirmIgnoreAll"
          >
            {{ $t("ignore_selected") }}
          </v-btn>
          <v-btn
            color=""
            text
            rounded
            depressed
            class="pl-5 pr-5"
            @click="showBulkIgnoreConfirmDialog = false"
          >
            {{ $t("cancel") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Diálogo de confirmación para reactivar todas las sugerencias -->
    <v-dialog
      v-model="showBulkReactivateConfirmDialog"
      max-width="800px"
      persistent
    >
      <v-card>
        <v-card-title class="text-h5">
          {{ $t("confirm_reactivate_all_suggestions") }}
        </v-card-title>
        <v-card-text>
          <div class="text-body-2 mb-4">
            {{
              $t("about_to_reactivate_suggestions", {
                count: selectedItems.length
              })
            }}
          </div>
          <ul class="suggestions-list">
            <li
              v-for="suggestion in selectedItems"
              :key="suggestion.id"
              class="suggestion-item"
            >
              <strong>{{ getFormattedDate(suggestion.target_date) }}</strong>
              - {{ $t("initial_price") }}: {{ suggestion.price_initial }}€ →
              {{ $t("final_price") }}:
              <strong>{{ suggestion.price_suggestion }}€</strong>
            </li>
          </ul>
        </v-card-text>

        <v-card-actions class="ps-5 pb-5 justify-center">
          <v-btn
            color="secondary"
            class="pl-5 pr-5"
            rounded
            @click="confirmReactivateAll"
          >
            {{ $t("reactivate_selected") }}
          </v-btn>
          <v-btn
            color=""
            text
            rounded
            depressed
            class="pl-5 pr-5"
            @click="showBulkReactivateConfirmDialog = false"
          >
            {{ $t("cancel") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Rule Info dialog -->
    <a-pricing-strategy-rule-definition-info-dialog />
  </div>
</template>

<script>
import aBaseComponent from "@/components/aBaseComponent";
import aCard from "@/components/aCard";
import aPricingStrategyApplyStrategy from "@/components/pricing-strategy/aPricingStrategyApplyStrategy";
import aPricingStrategyCardStrategyRuleMini from "@/components/pricing-strategy/aPricingStrategyCardStrategyRuleMini.vue";
import aPricingStrategyRuleDefinitionInfoDialog from "@/components/pricing-strategy/aPricingStrategyRuleDefinitionInfoDialog";
import { measurePhrase } from "@/components/pricing-strategy/pricingStrategyUtils";
import aKpi from "@/components/rms_ui/aKpi";
import * as Utils from "@/utils.js";
import Vue from "vue";
import { mapGetters, mapState } from "vuex";

export default {
  name: "a-pricing-strategy-recommendations",
  components: {
    aBaseComponent,
    aCard,
    aKpi,
    aPricingStrategyApplyStrategy,
    aPricingStrategyCardStrategyRuleMini,
    aPricingStrategyRuleDefinitionInfoDialog
  },
  data: () => ({
    // Vista de la tabla: recomendaciones de precio o avisos. Nunca las dos:
    // mezcladas no se entendía qué proponía cada día ni por qué.
    suggestion_view: "price",
    subscribed_modules: [
      "pricingstrategy_recommendations",
      "pricingstrategy_strategy_rates",
      "pricingstrategy_strategies",
      "pricingstrategy_rules",
      "pricingstrategy_guardrails",
      "pricingstrategy_rule_types",
      "pricingstrategy_strategy_room_types",
      "pricingstrategy_strategy_config"
    ],
    selectedItems: [],
    expandedByDate: {},
    showConfirmationDialog: false,
    showBulkIgnoreConfirmDialog: false,
    showBulkReactivateConfirmDialog: false,
    pendingSuggestionsForConfirmation: [],
    generating_fake_suggestions: false
  }),
  computed: {
    recommendations_from_date: {
      get() {
        return this.$store.state.pricingstrategy.recommendations_from_date;
      },
      set(value) {
        this.$store.dispatch(
          "setPricingStrategyRecommendationsFromDate",
          value
        );
      }
    },
    recommendations_to_date: {
      get() {
        return this.$store.state.pricingstrategy.recommendations_to_date;
      },
      set(value) {
        this.$store.dispatch("setPricingStrategyRecommendationsToDate", value);
      }
    },
    recommendations_rate_plan_id: {
      get() {
        return this.$store.state.pricingstrategy.recommendations_rate_plan_id;
      },
      set(value) {
        this.$store.dispatch(
          "setPricingStrategyRecommendationsRatePlanId",
          value
        );
      }
    },
    recommendations_strategy_id: {
      get() {
        return this.$store.state.pricingstrategy.recommendations_strategy_id;
      },
      set(value) {
        this.$store.dispatch(
          "setPricingStrategyRecommendationsStrategyId",
          value
        );
      }
    },
    headers() {
      return [
        {
          text: this.$t("hour"),
          value: "hour",
          sortable: false,
          align: "left"
        },
        {
          text: this.$t("target_day"),
          value: "target_day",
          sortable: true,
          align: "center"
        },
        {
          text: this.$t("anticipation"),
          value: "anticipation",
          sortable: true,
          align: "center"
        },
        {
          text: this.$t("rate"),
          value: "rate",
          sortable: true,
          align: "center"
        },
        {
          text: this.$t("initial_price"),
          value: "price_initial_formatted",
          sortable: true,
          align: "center"
        },
        // Un aviso no propone precio: sin diferencia que enseñar, y la columna
        // de la sugerencia pasa a ser el nivel del aviso.
        ...(this.isPriceView
          ? [
              {
                text: this.$t("difference"),
                value: "difference",
                sortable: true,
                align: "center"
              }
            ]
          : []),
        {
          text: this.isPriceView ? this.$t("suggestion") : this.$t("level"),
          value: "price_suggestion_formatted",
          sortable: true,
          align: "center"
        },
        {
          text: this.$t("measure"),
          value: "measure",
          sortable: false,
          align: "center"
        },
        {
          text: this.$t("rule"),
          value: "rule",
          sortable: false,
          align: "center",
          class: "no-margin"
        },
        // Sin nada que aplicar, la columna de acciones sobra
        ...(this.isPriceView
          ? [
              {
                text: this.$t("actions"),
                value: "action",
                sortable: false,
                align: "right",
                width: "170px"
              }
            ]
          : [])
      ];
    },
    strategies_items() {
      const items = [
        {
          text: this.$t("all_strategies"),
          value: null
        }
      ];
      this.strategies.forEach(strategy => {
        items.push({
          text: strategy.name,
          value: strategy.id
        });
      });
      return items;
    },
    strategy_rates_items() {
      const items = [
        {
          text: this.$t("all_rates"),
          value: null
        }
      ];
      this.strategy_rates.forEach(rate => {
        items.push({
          text: rate.code,
          value: rate.id
        });
      });
      return items;
    },
    formattedRecommendations() {
      if (!this.recommendations || !this.strategy_rates) {
        return [];
      }

      // Hacer que sea reactivo a expandedByDate
      const expandedState = this.expandedByDate;

      // Agrupar por fecha de recomendación y procesar cada grupo
      const groupedByDate = {};
      const isNotifyView = !this.isPriceView;

      this.recommendations.forEach(recommendation => {
        const date = recommendation.date;
        if (!groupedByDate[date]) {
          groupedByDate[date] = [];
        }

        // Crear fila principal de la recomendación
        const ratePlan = this.getPricingStrategyStrategyRatePlanById(
          recommendation.rate_plan_id
        );
        const rateCode = ratePlan ? ratePlan.code : "N/A";

        // La vista manda: o precios o avisos, nunca los dos a la vez. Un día
        // sin nada de lo que se está mirando no sale.
        const suggestions = (recommendation.suggestions || []).filter(s =>
          isNotifyView
            ? s.suggestion_type === "notify"
            : s.suggestion_type !== "notify"
        );
        if (!suggestions.length) {
          return;
        }

        // Si solo hay una suggestion, incluir sus datos en la fila principal
        const singleSuggestion =
          suggestions.length === 1 ? suggestions[0] : null;

        const mainRowId = `${date}_${recommendation.id}`;
        const isExpanded =
          expandedState[date] && expandedState[date].includes(mainRowId);

        const mainRow = {
          ...recommendation,
          id: recommendation.id,
          row_id: mainRowId,
          hour: recommendation.time,
          target_day: Vue.moment(recommendation.target_date).format(
            "D MMM YYYY"
          ),
          anticipation: `${recommendation.anticipation} ${this.$t("days")}`,
          rate: rateCode,
          price_initial: recommendation.price_initial,
          price_initial_formatted: `${recommendation.price_initial}€`,
          price_current: recommendation.price_current,
          price_suggestion: isNotifyView
            ? null
            : recommendation.price_suggestion,
          price_suggestion_formatted:
            !isNotifyView && recommendation.price_suggestion
              ? `${recommendation.price_suggestion}€`
              : "",
          // Reutiliza el camino de la fila de solo aviso: campana en lugar de
          // importe, sin casilla y sin acciones que aplicar.
          notify_only: isNotifyView || !!recommendation.notify_only,
          suggestions_count: suggestions.length,
          // Datos de la suggestion única (si aplica)
          has_multiple_suggestions: suggestions.length > 1,
          single_suggestion: singleSuggestion,
          single_suggestion_rule: this.suggestionRule(singleSuggestion),
          isSubRow: false,
          // Una fila que sólo trae avisos no propone precio: no hay nada que
          // aplicar ni que seleccionar en bloque.
          selectable: !(isNotifyView || recommendation.notify_only),
          isExpanded: isExpanded
        };

        groupedByDate[date].push(mainRow);

        // Si tiene múltiples sugerencias Y está expandido, agregar las subfilas
        if (suggestions.length > 1 && isExpanded) {
          // Ordenadas por su papel en el cálculo: primero lo que suma, luego
          // lo que sobrescribe. El orden dentro de cada grupo se respeta,
          // porque entre dos tarifas fijas manda la última.
          const ordered = suggestions
            .map((s, i) => ({ s, i }))
            .sort(
              (a, b) =>
                this.suggestionRole(a.s) - this.suggestionRole(b.s) || a.i - b.i
            )
            .map(x => x.s);

          const decider = this.priceDecider(suggestions);

          ordered.forEach((suggestion, index) => {
            const subRow = {
              id: suggestion.id,
              row_id: `${date}_${recommendation.id}_sub_${index}`,
              parentId: mainRow.row_id,
              isSubRow: true,
              selectable: false,
              // Datos comunes de la fila principal
              hour: recommendation.time,
              target_day: Vue.moment(recommendation.target_date).format(
                "D MMM YYYY"
              ),
              anticipation: `${recommendation.anticipation}`,
              rate: rateCode,
              price_initial: recommendation.price_initial,
              price_initial_formatted: `${recommendation.price_initial}€`,
              // Datos específicos de la sugerencia
              price_suggestion: suggestion.price_suggestion,
              price_suggestion_formatted: `${suggestion.price_suggestion}€`,
              single_suggestion: suggestion,
              suggestion_rule: this.suggestionRule(suggestion),
              // Si hay tarifa fija, sólo cuenta ella; si no, cuentan todos los
              // ajustes, que se suman.
              contributes: decider
                ? suggestion.id === decider.id
                : suggestion.suggestion_type !== "notify",
              overriddenBy:
                decider && suggestion.id !== decider.id
                  ? (this.suggestionRule(decider) || {}).name
                  : null,
              ...suggestion
            };
            groupedByDate[date].push(subRow);
          });
        }
      });

      // Crear objeto ordenado con fechas más nuevas arriba
      const sortedGrouped = {};
      const sortedDates = Object.keys(groupedByDate).sort((a, b) => {
        return Vue.moment(b).valueOf() - Vue.moment(a).valueOf();
      });

      sortedDates.forEach(date => {
        sortedGrouped[date] = groupedByDate[date];
      });

      return sortedGrouped;
    },
    isPriceView() {
      return this.suggestion_view === "price";
    },
    // Sólo se muestra en entornos de desarrollo; el backend vuelve a validarlo
    fake_suggestions_enabled() {
      return !!(
        this.strategy_config &&
        this.strategy_config.dev_tools &&
        this.strategy_config.dev_tools.fake_suggestions_enabled
      );
    },
    ...mapState({
      recommendations: state => state.pricingstrategy.recommendations,
      rules: state => state.pricingstrategy.rules,
      strategy_rates: state => state.pricingstrategy.strategy_rates,
      strategies: state => state.pricingstrategy.strategies,
      strategy_config: state => state.pricingstrategy.strategy_config,
      // Los avisos reutilizan la escala de prioridades de Alertas para que el
      // color signifique lo mismo en toda la aplicación.
      highlight_priorities: state => state.highlight_priorities
    }),
    ...mapGetters({
      current_hotel: "current_hotel",
      getPricingStrategyStrategyRatePlanById:
        "getPricingStrategyStrategyRatePlanById",
      getPricingStrategyRuleOrGuardrailById:
        "getPricingStrategyRuleOrGuardrailById"
    })
  },
  methods: {
    // ── Avisos ──────────────────────────────────────────────────────────────
    // Un aviso no propone precio, así que sus columnas de importe quedan
    // vacías. Para que la tabla se lea de una pasada, ocupa el sitio de la
    // sugerencia con la campana de Alertas, y el color dice la prioridad.
    // Avisos de la fila: el único de la subfila, o todos los de una fila
    // principal que no propone precio porque sólo ha disparado avisos.
    notifiesOf(item) {
      if (!item) {
        return [];
      }
      if (item.single_suggestion) {
        return item.single_suggestion.suggestion_type === "notify"
          ? [item.single_suggestion]
          : [];
      }
      const suggestions = item.suggestions || [];
      return suggestions.length &&
        suggestions.every(s => s.suggestion_type === "notify")
        ? suggestions
        : [];
    },
    isNotify(item) {
      return this.notifiesOf(item).length > 0;
    },
    notifyPriority(item) {
      // Con varios avisos manda el más grave: es el que marca el color.
      const priority = this.notifiesOf(item).reduce(
        (max, s) => (s.priority > max ? s.priority : max),
        null
      );
      return (
        (this.highlight_priorities || []).find(p => p.id === priority) || null
      );
    },
    notifyColor(item) {
      const priority = this.notifyPriority(item);
      return priority ? priority.color : "grey";
    },
    // Las clases de texto de Vuetify no son el nombre del color tal cual:
    // "indigo darken-2" se escribe "indigo--text text--darken-2". Concatenar
    // "--text" al color entero daba una clase inválida que acababa pintando
    // el fondo en vez de la letra.
    notifyTextClass(item) {
      const [base, modifier] = this.notifyColor(item).split(" ");
      return modifier
        ? [`${base}--text`, `text--${modifier}`]
        : [`${base}--text`];
    },
    // Literal del nivel del aviso ("Alta", "Media", "Baja")
    notifyLevel(item) {
      const priority = this.notifyPriority(item);
      return priority ? this.$t(priority.literal) : "";
    },
    notifyTooltip(item) {
      const priority = this.notifyPriority(item);
      return priority
        ? this.$t("recommendation_notify_priority", {
            priority: this.$t(priority.literal)
          })
        : this.$t("recommendation_notify");
    },

    // Regla que disparó una sugerencia, en la forma que consume la card.
    //
    // La estructura sale de la propia sugerencia (`rule_settings`), no del
    // dataset: así se enseña la regla TAL COMO ERA cuando se generó, y además
    // funciona con el guardarail fijo de mín/máx, que no está en `rules` ni en
    // `guardrails` — llega dentro de /get-strategy y aquí no se carga ninguna.
    // La búsqueda queda solo para el nombre y el color.
    // Rol de una sugerencia en el cálculo del precio, que es lo que decide
    // dónde se pinta: los ajustes se suman entre ellos, una tarifa fija los
    // descarta y fija el precio, y los guardarailes actúan al final sobre lo
    // que haya quedado. Pintarlas en ese orden hace visible la precedencia.
    suggestionRole(suggestion) {
      const rule = this.suggestionRule(suggestion);
      if (rule && rule.rule_kind === "guardrail") return 2;
      return suggestion.suggestion_type === "fixed_price" ? 1 : 0;
    },
    // Cuál de las sugerencias ha decidido el precio final.
    //
    // Reproduce la precedencia de StrategyApi::setPricingSuggestions(): manda
    // la ÚLTIMA tarifa fija que llega y, si no hay ninguna, la suma de los
    // ajustes. Si allí cambia el criterio, hay que cambiarlo aquí.
    priceDecider(suggestions) {
      const fixed = suggestions.filter(
        s => s.suggestion_type === "fixed_price"
      );
      return fixed.length ? fixed[fixed.length - 1] : null;
    },
    suggestionRule(suggestion) {
      if (!suggestion || !suggestion.rule_id) return null;
      const known = this.getPricingStrategyRuleOrGuardrailById(
        suggestion.rule_id
      );
      const settings = suggestion.rule_settings || (known && known);
      if (!settings) return null;
      const schedule = settings.schedule;
      const isGuardrail = known
        ? known.rule_kind === "guardrail"
        : !!(schedule && schedule.frequency === "on_change");
      return {
        id: suggestion.rule_id,
        rule_kind: isGuardrail ? "guardrail" : "rule",
        name: (known && known.name) || this.conditionsName(settings),
        color: (known && known.color) || "#E0E5EA",
        routes: settings.routes || [],
        action: settings.action || {},
        schedule
      };
    },
    // Nombre de emergencia para lo que no está en ningún dataset — hoy solo el
    // guardarail fijo de mín/máx. Se compone con los tipos de sus condiciones,
    // que es lo que un humano reconocería: "Precio Mínimo / Precio Máximo".
    conditionsName(settings) {
      const codes = [];
      (settings.routes || []).forEach(route =>
        (route.conditions || []).forEach(condition => {
          const code = condition.rule_type_code;
          if (code && codes.indexOf(code) === -1) codes.push(code);
        })
      );
      const titles = codes.map(code => {
        const key = `pricing_strategy_rule_type_card_type_${code}`;
        return this.$te(key) ? this.$t(key) : code;
      });
      return titles.length
        ? titles.join(" / ")
        : this.$t("guardrail_generic_name");
    },
    // Genera sugerencias de prueba a partir de las reglas configuradas.
    // Sólo disponible en entornos de desarrollo.
    generateFakeSuggestions() {
      this.generating_fake_suggestions = true;
      this.$store
        .dispatch("generatePricingStrategyFakeSuggestions")
        .then(response => {
          const total = response.data ? response.data.total_suggestions : 0;
          const warnings =
            response.data && response.data.warnings
              ? response.data.warnings
              : [];
          if (total > 0) {
            this.$store.dispatch("setSnackbar", {
              title: this.$t("generate_fake_suggestions"),
              text: this.$t("fake_suggestions_generated", { total: total }),
              color: "success"
            });
          } else {
            this.$store.dispatch("setSnackbar", {
              title: this.$t("generate_fake_suggestions"),
              text: warnings.length
                ? warnings[0]
                : this.$t("fake_suggestions_none"),
              color: "warning"
            });
          }
        })
        .catch(error => {
          const backend_message =
            error.response && error.response.data
              ? error.response.data.message
              : null;
          this.$store.dispatch("setSnackbar", {
            title: this.$t("generate_fake_suggestions"),
            text: backend_message || error.message,
            color: "error"
          });
        })
        .finally(() => {
          this.generating_fake_suggestions = false;
        });
    },
    isPastDate(date) {
      return Vue.moment(date).isBefore(Vue.moment().format("YYYY-MM-DD"));
    },
    getExpandedForDate(date) {
      return this.expandedByDate[date] || [];
    },
    setExpandedForDate(date, expanded) {
      this.$set(this.expandedByDate, date, expanded);
    },
    toggleExpand(date, itemId) {
      const currentExpanded = this.getExpandedForDate(date);
      const newExpanded = currentExpanded.includes(itemId)
        ? currentExpanded.filter(id => id !== itemId)
        : [...currentExpanded, itemId];
      this.setExpandedForDate(date, newExpanded);
    },

    getFormattedDate(date) {
      return Vue.moment(date).format("dddd, DD MMMM YYYY");
    },

    getSuggestionsText(count) {
      return count === 1 ? this.$t("suggestion") : this.$t("suggestions");
    },
    // Explicación de por qué ha saltado la sugerencia (measure interpolada)
    getMeasureText(sug) {
      return sug && sug.measure ? measurePhrase(this, sug) : "";
    },
    getRowClass(item) {
      const classes = ["suggestion-row"];
      if (item.isSubRow) {
        classes.push("suggestion-sub-row");
      }
      // Una regla que saltó pero no ha movido el precio se apaga: se sigue
      // viendo (saber qué NO se aplicó es parte de entender el número) pero
      // no compite con las que sí cuentan.
      if (item.isSubRow && item.contributes === false) {
        classes.push("suggestion-unused");
      }
      if (item.status === "ignored") {
        classes.push("suggestion-ignored");
      }
      return classes.join(" ");
    },
    handleExpandClick(date, item) {
      this.toggleExpand(date, item.row_id);
    },
    isDateToday(date) {
      return Vue.moment(date).isSame(Vue.moment(), "day");
    },
    // Apply all recommendations ----------------------------------------
    showApplyAllDialog() {
      if (!this.recommendations || this.recommendations.length === 0) {
        this.$store.dispatch("setSnackbar", {
          title: this.$t("no_recommendations_to_apply"),
          color: "warning"
        });
        return;
      }

      const today = Vue.moment().format("YYYY-MM-DD");
      const pendingSuggestions = this.recommendations.filter(recommendation => {
        // Un aviso no propone precio: no entra en el envío masivo.
        if (recommendation.notify_only) {
          return false;
        }

        // Verificar que recommendation.date sea hoy
        const isDateToday =
          Vue.moment(recommendation.date).format("YYYY-MM-DD") === today;

        // Verificar que target_date sea hoy o futuro
        const isTargetDateTodayOrFuture = Vue.moment(
          recommendation.target_date
        ).isSameOrAfter(today, "day");

        // Verificar estado (igual que antes)
        const isPriceUnchanged =
          recommendation.price_initial === recommendation.price_current;
        const isUserModifiedPrice =
          recommendation.price_initial !== recommendation.price_current &&
          recommendation.price_current !== recommendation.price_suggestion;

        // Verificar que no sea ignorada
        const isNotIgnored = recommendation.status !== "ignored";

        // Solo incluir si cumple TODOS los criterios
        return (
          isDateToday &&
          isTargetDateTodayOrFuture &&
          (isPriceUnchanged || isUserModifiedPrice) &&
          isNotIgnored
        );
      });

      if (pendingSuggestions.length === 0) {
        this.$store.dispatch("setSnackbar", {
          title: this.$t("no_recommendations_to_apply"),
          color: "warning"
        });
        return;
      }

      // Preparar datos para el diálogo de confirmación
      this.pendingSuggestionsForConfirmation = pendingSuggestions.map(
        recommendation => {
          const refKey = `applyStrategy_${recommendation.id}`;
          const componentRef = this.$refs[refKey];

          // Si existe la referencia y tiene el valor modificado, usarlo
          // Si no, usar el precio de sugerencia original
          let finalPrice = recommendation.price_suggestion;
          if (componentRef && componentRef.length > 0) {
            const component = componentRef[0];
            if (
              component.pricing_strategy_value !== null &&
              component.pricing_strategy_value !== undefined
            ) {
              finalPrice = component.pricing_strategy_value;
            }
          }

          return {
            id: recommendation.id,
            price: finalPrice,
            price_initial: recommendation.price_initial,
            target_date: recommendation.target_date
          };
        }
      );

      // Mostrar diálogo de confirmación
      this.showConfirmationDialog = true;
    },
    confirmSendAll() {
      this.$store.dispatch("setSnackbar", {
        title: this.$t("applying_all_recommendations"),
        color: "secondary"
      });

      this.$store
        .dispatch("applyPricingStrategySuggestions", {
          hotel_id: this.current_hotel.id,
          suggestions: this.pendingSuggestionsForConfirmation
        })
        .then(() => {
          this.$store.dispatch("setSnackbar", {
            title: this.$t("all_recommendations_applied_successfully", {
              count: this.pendingSuggestionsForConfirmation.length
            }),
            color: "accent"
          });
          this.showConfirmationDialog = false;
        })
        .catch(error => {
          // console.error("Error applying all recommendations:", error);
          Utils.showError(this, "error_applying_all_recommendations");
        });
    },
    confirmIgnoreAll() {
      this.$store.dispatch("setSnackbar", {
        title: this.$t("ignoring_price_suggestion"),
        color: "secondary"
      });
      const data = {
        hotel_id: this.current_hotel.id,
        suggestions: this.selectedItems.map(item => ({ id: item.id }))
      };
      this.$store
        .dispatch("ignorePricingStrategySuggestion", data)
        .then(() => {
          this.showBulkIgnoreConfirmDialog = false;
          this.$store.dispatch("setSnackbar", {
            title: this.$t("price_suggestion_ignored"),
            color: "accent"
          });
        })
        .catch(error => {
          this.showBulkIgnoreConfirmDialog = false;
          Utils.showError(this, "price_suggestion_not_ignored");
        });
    },
    confirmReactivateAll() {
      this.$store.dispatch("setSnackbar", {
        title: this.$t("reactivating_price_suggestion"),
        color: "secondary"
      });
      const data = {
        hotel_id: this.current_hotel.id,
        suggestions: this.selectedItems.map(item => ({ id: item.id }))
      };
      this.$store
        .dispatch("reactivatePricingStrategySuggestion", data)
        .then(() => {
          this.showBulkReactivateConfirmDialog = false;
          this.$store.dispatch("setSnackbar", {
            title: this.$t("price_suggestion_reactivated"),
            color: "accent"
          });
        })
        .catch(error => {
          this.showBulkReactivateConfirmDialog = false;
          Utils.showError(this, "price_suggestion_not_reactivated");
        });
    },
    // Initialize filters ------------------------------------------------
    initFilters() {
      this.recommendations_from_date = Vue.moment()
        .subtract(3, "days")
        .format("YYYY-MM-DD");
      this.recommendations_to_date = Vue.moment().format("YYYY-MM-DD");
    }
  },
  watch: {
    strategy_rates() {
      this.initFilters();
    },
    strategies() {
      this.initFilters();
    },
    rules() {
      this.initFilters();
    },
    recommendations() {
      // Limpiar estados de expansión cuando cambien las recomendaciones
      this.expandedByDate = {};
    }
  }
};
</script>

<style scoped lang="scss">
// El selector vive al lado de los desplegables de Estrategia y Tarifa: misma
// altura, mismo grosor de borde y sin fondo propio. El activo sí se tinta, que
// es lo único que lo distingue del otro.
// El borde lo fija Vuetify con `!important` y cinco clases
// (.theme--light.v-btn-toggle:not(...) .v-btn.v-btn), así que hay que subir la
// especificidad para poder igualar el de los desplegables.
.suggestion-view-toggle.v-btn-toggle.theme--light {
  ::v-deep .v-btn.v-btn {
    height: 40px !important;
    border-color: rgba(0, 0, 0, 0.38) !important;
    opacity: 1;
  }
  ::v-deep .v-btn.v-btn:not(.v-btn--active) {
    background-color: transparent !important;
  }
  // El activo se rellena como el botón de enviar. El relleno y el blanco los
  // ponen las clases `secondary white--text` de Vuetify desde la plantilla,
  // que es lo mismo que recibe aquel botón de su `color="secondary"`; aquí
  // sólo se quita el borde gris para que no recuadre el relleno.
  ::v-deep .v-btn.v-btn--active {
    border-color: transparent !important;
  }
}
// Regla que saltó pero cuyo importe no está en el precio final
.suggestion-unused {
  opacity: 0.45;
  ::v-deep .a-kpi-price,
  ::v-deep .a-kpi {
    text-decoration: line-through;
  }
}
.a-kpi {
  justify-content: start !important;
}
.a-kpi-price {
  font-size: 14px !important;
  font-weight: 400 !important;
  letter-spacing: 0.1px !important;
  line-height: 1 !important;
}
.card-table-row {
  &:last-child {
    margin-bottom: 20px;
  }
}
.v-data-table {
  ::v-deep th {
    font-size: 10px !important;
  }
  ::v-deep > .v-data-table__wrapper table tbody tr:hover {
    background-color: #f5fdff !important;
  }
  ::v-deep > .v-data-table__wrapper table thead tr th,
  ::v-deep > .v-data-table__wrapper table tbody tr td {
    padding-left: 14px !important;
    padding-right: 14px !important;
    white-space: nowrap;
  }
  ::v-deep > .v-data-table__wrapper table thead tr th:not(.no-margin) span {
    margin-left: 15px;
  }
  /* Ocultar solo el icono de expansión por defecto en otras posiciones */
  ::v-deep .v-data-table__expand-icon {
    display: none !important;
  }
}
.v-list {
  ::v-deep .v-list-item {
    display: flex;
    align-items: center;
    .v-list-item__icon {
      min-height: inherit !important;
      height: inherit !important;
      margin: 0px !important;
    }
    .v-list-item__content {
      padding: 0px !important;
    }
  }
}
.suggestion-row {
  &.suggestion-sub-row {
    background-color: #f5f5f5;
    &:hover {
      background-color: #e8e8e8 !important;
    }
    td {
      border-bottom: 1px solid #e0e0e0;
      &:last-child {
        border-bottom: none;
      }
    }
  }
  &.suggestion-ignored {
    background-color: #f8f8f8 !important;
    ::v-deep td {
      opacity: 0.3;
      &:last-child {
        opacity: 1;
        .v-input,
        .kpi-wrapper-2,
        .suggestion-modified,
        button {
          opacity: 0.3;
        }
      }
    }
  }
}
</style>
